export function unCapitalizeFirstLetter(str: string): string {
    return str[0].toLowerCase() + str.slice(1);
}

export function pascalCaseToKebabCase(str: string): string {
    return str.replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase();
}